import * as React from 'react';

import type { UStudioContextValue } from './types';

export const UStudioContext = React.createContext<UStudioContextValue | null>(
  null,
);
